import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bredcumbs',
  templateUrl: './bredcumbs.component.html',
  styleUrls: ['./bredcumbs.component.css']
})
export class BredcumbsComponent implements OnInit {
  title: string;
  constructor(private activatedRoute: ActivatedRoute) { 
    
  }

  ngOnInit(){
    this.activatedRoute.data.subscribe( bread => {
      if(bread && bread.breadcrumb){
        this.title = bread.breadcrumb;
      }
    })
  }

}
